import * as React from 'react';

import { Image } from './careers-benefits-stripes2.styles';

export const Stripes2View = ({ imageSrc }) => <Image src={imageSrc} alt="" />;
